import { decorate, action, observable } from "mobx";
import api from '../api';
import config from '../config';


const MAX_REFRESH_COUNT = 3;

function checkVersion(portalVersion) {
  const lsRefreshCountPath = `${config.portalName}-refresh-count-${config.version}-${portalVersion}`;
  if (portalVersion > config.version) {
    let refreshCount = parseInt(localStorage.getItem(lsRefreshCountPath));
    if (isNaN(refreshCount))
      refreshCount = 0;
    localStorage.setItem(lsRefreshCountPath, ++refreshCount);
    if (refreshCount < MAX_REFRESH_COUNT)
      location.reload();
  }
}
class AppStore {
  constructor() {
    this.currentUser = null;
    this.isLoggingIn = false;
    this.isLoggedIn = false;
    this.search = "";
    this.isFetching = false;
    this.events = [];
    this.products = [];
    this.portal = null;
  }

  setEvents(events) {
    this.events = events;
  }

  setPortal(portal) {
    this.portal = portal;
  }

  setProducts(products) {
    this.products = products;
  }

  setUser(userData) {
    this.currentUser = userData;
    this.isLoggingIn = false;
    this.isLoggedIn = !!userData;
  }

  setIsLoggingIn(val) {
    this.isLoggingIn = !!val;
  }

  setSearch(val) {
    this.search = val;
  }
  setIsFetching(val) {
    this.isFetching = val;
  }
  fetchPortal() {
    return new Promise((resolve, reject) => {
      api.getPortal().then(portal => {
        checkVersion(portal.version);
        this.setEvents(portal.events);
        this.setProducts(portal.products);
        this.setPortal(portal);
        resolve(portal);
      }).catch(reject);
    });
  }
  fetchEvents() {
    return new Promise((resolve, reject) => {
      api.getEvents().then(resp => resp.body).then(events => {
        this.setEvents(events);
        resolve(events);
      }).catch(reject);
    });
  }
}

decorate(AppStore, {
  currentUser: observable,
  isLoggingIn: observable,
  isLoggedIn: observable,
  isFetching: observable,
  search: observable,
  portal: observable,
  events: observable,
  products: observable,
  setUser: action,
  setEvents: action,
  setPortal: action,
  fetchEvents: action,
  //setSearch: action,
});

const configureStore = () => new AppStore();

export default configureStore;
